export default {
  title: "Отбелязани",
  subtitle: "Вашите отбелязани елементи",
  comingSoon: "Очаквайте скоро",
  description: "Тази функция ще ви позволи да отбелязвате и бързо да достъпвате важни елементи.",
};
